<template>
  <Dialog :show="show" @cancel="cancelDialog">
    <div class="calm">
      <div class="calm-top">
        <div class="calm-top__name">
          汇率更新时间({{ budgetProfitData.rateTime }})
          {{ countryAbbreviationArray[budgetProfitData.countrySite] }}/RMB即时汇率:
          <span class="calm-top__value">{{ budgetProfitData.rate[budgetProfitData.countrySite] }}</span>
        </div>
        <div class="calm-top__name">
          {{ sellerTypeTextArray[budgetProfitData.sellerType] }}卖家帐户月费:
          <span class="calm-top__tip">({{ countryCurrencyArray[budgetProfitData.countrySite] }})</span>
          <span class="calm-top__value">
            <template v-if="budgetProfitData.sellerType == 0">{{ nationalCurrencyArray[budgetProfitData.countrySite] }}{{budgetProfitData.sellerAccountMonthlyFee}}/月</template>
            <template v-else>$0/月</template>
          </span>
        </div>
        <div class="calm-top__name">
          当月仓储费:
          <span class="calm-top__tip">
            ({{ countryCurrencyArray[budgetProfitData.countrySite] }})
          </span>
          <span class="calm-top__value">
            {{ nationalCurrencyArray[budgetProfitData.countrySite] }}{{ budgetProfitData.monthlyStorageFee }}/m³
          </span>
        </div>
      </div>
      <div class="calm-input">
        <div class="calm-input__title">FBA商品原始数据</div>
        <inputModule
          :budget-profit-data="budgetProfitData"
          :is-show-result="true"
          @budgetChange="changeBudgetComponentData"
          @openTaxDialog="informUpOpenDialog('input')"
          :is-disable="isDisable"></inputModule>
      </div>
      <div class="calm-tip">
        温馨提示: 如需更详细更准确的"商品,店铺,公司3个层级"的成本与费用分解, 利润预核算及业财一体化等统计分析功能, 
        <span class="calm-tip__click" @click="functionalDevelopmentInProgress">点击注册会员</span>
      </div>
      <div class="calm-cal">
        <div class="calm-cal-left">
          <div class="calm-cal__title">单位商品成本与费用分摊</div>
          <div class="calm-cal-left-module">
            <div class="calm-cal__block"
              v-for="(item, index) in budgetCostCalData"
              :key="index">
              <div class="calm-cal__line"
                v-for="(input, i) in item.input"
                :key="input.data">
                <div class="calm-cal__name"
                  :class="{'calm-cal__name--selected' : input.html && input.showDetail}">
                  {{ input.name }}
                  <template v-if="input.html">
                    <img src="../img/问号.png" alt=""
                      class="calm-cal__img"
                      @mouseover="showDetailHtml(index, i)"
                      @mouseleave="cancelDetailHtml(index, i)">
                    <div
                      class="calm-cal__detail"
                      v-html="input.html"
                      v-show="input.showDetail"></div>
                  </template>
                </div>
                <div class="calm-cal__value">
                  <i class="el-icon-loading calm-cal__icon" v-show="input.isRefresh"></i>
                  ￥{{ keepDecimalPoint(budgetProfitData[input.data], input.decimal) }}{{ getUnitEnum(input.unit) }}
                </div>
                <template v-if="input.data === 'getComprehensiveTaxesAndFeesOfTheImportingCountry'">
                  <div class="calm-cal__down" @click="informUpOpenDialog()"></div>
                </template>
              </div>
            </div>
          </div>
          <div class="calm-cal-bottom">
              <div class="calm-cal-bottom__left">成本汇总：</div>
              <div class="calm-cal-bottom__right">
                <!-- 卖家账户固定费用 -->
                <div v-if="false">
                  <div class="calm-cal-bottom__btn"
                    :style="{ background: budgetProfitData.calType ? '#99D8E7' : '' }"
                    @click="inputChangeInformUp($event, 'calType', (Number(budgetProfitData.calType) + 1) % 2)">
                    <template v-if="budgetProfitData.calType">计算卖家账户固定费用</template>
                    <template v-else>忽略卖家账户固定费用</template>
                  </div>
                </div>
                ￥{{ keepDecimalPoint(budgetProfitData.getCostSummary, 1) }}{{ getUnitEnum('perUnit') }}
              </div>
          </div>
        </div>
        <div class="calm-cal-right">
          <div class="calm-cal__title">当月销售额,收汇,利润及利润率</div>
          <div class="calm-cal__line1"
            v-for="(item, index) in budgetedProfitCalData"
            :key="item.data">
            <div class="calm-cal__name"
              :class="{'calm-cal__name--selected' : item.html && item.showDetail}">
              {{ item.name }}
              <span class="calm-cal__tip" v-if="item.data === 'getActualSalesVolumeForTheMonth'">(扣减退货)</span>
              <template v-if="item.html">
                <img src="../img/问号.png" alt=""
                  class="calm-cal__img"
                  @mouseover="showDetailHtml(index)"
                  @mouseleave="cancelDetailHtml(index)">
                <div class="calm-cal__detail calm-cal__detail1" v-html="item.html" v-show="item.showDetail"></div>
              </template>
            </div>
            <div class="calm-cal__value">
              <template
                v-if="item.data !== 'getActualSalesVolumeForTheMonth'
                && item.data !== 'getMonthlySalesProfitMargin'
                && item.data !== 'getMonthlyCostProfitMargin'">￥
              </template>{{ keepDecimalPoint(budgetProfitData[item.data], item.decimal) }}{{ getUnitEnum(item.unit) }}
              <template
                v-if="item.data === 'getMonthlySalesProfitMargin'
                || item.data === 'getMonthlyCostProfitMargin'">%
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="calm-cal__bottom" v-show="isDisable">
        <div class="calm-cal__btn" @click="editBtnClick()">修改</div>
      </div>
    </div>
  </Dialog>
</template>

<script>
  import { BudgetProfitTest, ProfitInputNewModule, INPUTENUM } from "common/dataClass/Profit";
  import inputModule from "./inputModule.vue";
  import Dialog from "components/common/Dialog.vue";
  import globalData from "common/globalData";
  import DefaultAxios from 'service/default'
  export default {
    name: "calmDialog",
    components: {
      'inputModule': inputModule,
      Dialog
    },
    props: {
      /**是否显示弹窗 */
      show: {
        type: Boolean,
        default: false,
        required: true
      },
      /**预算计算基础数据 */
      budgetProfitData: {
        type: BudgetProfitTest
      },
    },
    data() {
      return {
        /**货币数组 */
        countryCurrencyArray: globalData.countryCurrencyInvariant,
        /**货币缩写 */
        nationalCurrencyArray: globalData.nationalCurrencyInvariant,
        /**国家缩写 */
        countryAbbreviationArray: globalData.countryAbbreviationInvariant,
        /**卖家账户类型文字数组 */
        sellerTypeTextArray: globalData.sellerTypeInputOptions.map(s => s.slice(0, -2)),
        /**会员会费 */
        warehouseFeeArray: globalData.warehouseFee,
        /**预算成本显示数据 */
        budgetCostCalData: ProfitInputNewModule.NEWCAL(),
        /**预算利润显示数据 */
        budgetedProfitCalData: ProfitInputNewModule.NEWPROFIT(),
        /**定时器 */
        detailTimer: null,
        /**是否禁用 */
        isDisable: true,
      }
    },
    methods: {
      /**组件修改预算数据 */
      changeBudgetComponentData(obj){
        if(!obj) return
        this.$emit('budgetChange', obj)
      },
      /**修改按钮点击事件 */
      editBtnClick(){
        this.isDisable = false
        DefaultAxios.modifyDataCollectionPoints()
      },
      /**取消计算弹窗 */
      cancelDialog(){
        this.$emit('cancel', false)
        this.isDisable = true
      },
      /**功能开发中 */
      functionalDevelopmentInProgress(){
        this.$message.error('暂未开通，敬请期待')
      },
      /**保留小数点数位 */
      keepDecimalPoint: globalData.keepDecimalPoint,
      /**获取对应的枚举单位 */
      getUnitEnum(unit){
        if(unit === INPUTENUM.NONE) return ''
        let arr = INPUTENUM.judgeEnumReturnString[unit]
        return arr[this.budgetProfitData.unit ? this.budgetProfitData.unit : 0]
      },
      /**鼠标停留在对应的输入框名称上 */
      showDetailHtml(index, i = null){
        const _this = this
        this.detailTimer = setTimeout(() => {
          i !== null ?
            _this.budgetCostCalData[index].input[i].showDetail = true :
            _this.budgetedProfitCalData[index].showDetail = true
        }, 500);
      },
      /**鼠标离开对应的输入框名称上 */
      cancelDetailHtml(index, i = null){
        clearTimeout(this.detailTimer)
        this.detailTimer = null
        i !== null ?
          this.budgetCostCalData[index].input[i].showDetail = false :
          this.budgetedProfitCalData[index].showDetail = false
      },
      /**输入框数据改变 通知父组件 */
      inputChangeInformUp(event, key, v = null){
        let value
        if(v === null){
          value = event.target.value
        }else {
          value = v
        }
        this.$emit('budgetChange', {
          key: key,
          value: value
        })
      },
      /**通知上级组件打开弹窗 */
      informUpOpenDialog(type){
        this.$emit('openTaxDialog', { bool: true, type: type ? type : 'dialog'})
      }
    },
    computed:{
      budgetProfitDataComponent(){
        return JSON.stringify(this.budgetProfitData)
      }
    },
    watch: {
      budgetProfitDataComponent: {
        immediate:false,
        handler(newVal, oldVal){
          let newValue = new BudgetProfitTest()
          let oldValue = new BudgetProfitTest()
          newValue.importData(JSON.parse(newVal))
          oldValue.importData(JSON.parse(oldVal))
          let obj = {}
          for(let calKey in this.budgetCostCalData){
            for(let inputKey in this.budgetCostCalData[calKey].input){
              obj = this.budgetCostCalData[calKey].input[inputKey]
              if(newValue[obj.data] !== oldValue[obj.data]){
                this.budgetCostCalData[calKey].input[inputKey].isRefresh = true
                this.budgetCostCalData[calKey].input[inputKey].timer = setTimeout(() => {
                  this.budgetCostCalData[calKey].input[inputKey].isRefresh = false
                  clearTimeout(this.budgetCostCalData[calKey].input[inputKey].timer)
                  this.budgetCostCalData[calKey].input[inputKey].timer = null
                }, 200)
              }
            }
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.calm{
  width: 1500px;
  overflow-x: visible;
  &-top{
    display: flex;
    justify-content: flex-end;
    &__name{
      margin: 0 5px;
      font-size: 14px;
    }
    &__tip{
      font-size: 12px;
      font-weight: lighter;
      color: #00a0c7;
    }
    &__value{
      color: #880015;
      font-weight: bold;
    }
  }
  &-input{
    &__title{
      color: #19acfd;
      font-weight: bold;
      font-size: 28px;
      padding: 0px 10px;
    }
  }
  &-tip{
    font-size: 16px;
    padding: 8px;
    text-align: center;
    background: #c5eaf3;
    color: #727272;
    font-weight: bold;
    &__click{
      text-decoration: underline;
      color: #00a0c7;
      &:hover{
        cursor: pointer;
        opacity: .6;
      }
    }
  }
  &-cal{
    display: flex;
    justify-content: space-between;
    padding: 2px 10px;
    &-left{
      &-module{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #8e8e8e
      }
    }
    &-bottom{
      font-size: 20px;
      font-weight: bold;
      color: #e01e1ef7;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 35px 10px 10px;
      &__right{
        display: flex;
      }
      &__btn{
        font-size: 12px;
        background-color: #ff7f27;
        color: white;
        padding: 5px 10px;
        border-radius: 5px;
        margin-right: 5px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &__title{
      color: #00a0c7;
      font-weight: bold;
      font-size: 20px;
    }
    &__block{
      display: inline-block;
      vertical-align: top;
      margin: 5px;
    }
    &__line{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      font-size: 14px;
      position: relative;
    }
    &__line1{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px;
      font-size: 14px;
    }
    &__name{
      width: 240px;
      min-width: 192px;
      color: black;
      position: relative;
      &--selected{
        color: #FCA605;
      }
    }
    &__tip{
      font-weight: bold;
      color: #19acfd;
    }
    &__value{
      width: 100px;
      min-width: 74px;
      font-weight: bold;
      color: #e01e1ef7;
      position: relative;
    }
    &__icon{
      color: #444444;
      position: absolute;
      left: -15px;
    }
    &__img{
      width: 12px;
      transform: translate(0px, 1px);
    }
    &__detail{
      position: absolute;
      background-color: #dbedfc;
      top: 10px;
      left: 0px;
      color: black;
      font-size: 12px;
      z-index: 10;
      line-height: 15px;
      border: 1px solid #a8a8a8;
      border-radius: 8px;
      padding: 5px;
      width: 700px;
      &::after{
        content: '';
        position: absolute;
        left: 8px;
        top: -6px;
        width: 10px;
        height: 10px;
        margin-bottom: -10px;
        background: inherit;
        /*自动继承父元素的背景*/
        transform: rotate(45deg);
        border-left: 1px solid #a8a8a8;
        border-top: 1px solid #a8a8a8;
      }
    }
    &__detail1{
      width: 300px;
    }
    &__bottom{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      float: right;
      transform: translateY(-20px);
    }
    &__btn{
      color: white;
      background-color: #1c99fd;
      border: none;
      font-weight: bold;
      outline: none;
      padding: 10px 30px;
      font-size: 14px;
      border-radius: 3px;
      margin: 0 20px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &__down{
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid black;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
